import { useEffect, useRef, useState } from 'react';

import type { ChatMessage } from '../components/AgentChatPageParts';

type AgentChatTab = 'chat' | 'inspector';

type UseAgentChatViewStateArgs = {
  activeSessionId?: string | null;
  messages: ChatMessage[];
};

export function useAgentChatViewState({
  activeSessionId,
  messages,
}: UseAgentChatViewStateArgs) {
  // AC-M7-6: inspector tab
  const [activeTab, setActiveTab] = useState<AgentChatTab>('chat');
  const bottomRef = useRef<HTMLDivElement>(null);

  // AC-CHAT-4 (fix): reset activeTab to 'chat' whenever the active session changes.
  // Prevents the Inspector tab from sticking across sessions (Defect B).
  useEffect(() => {
    setActiveTab('chat');
  }, [activeSessionId]);

  // Auto-scroll to bottom on new messages.
  useEffect(() => {
    bottomRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  return {
    activeTab,
    setActiveTab,
    bottomRef,
  };
}
